<template>
  <div class="pa-40 form-v1" v-if="selectedItem">
    <re_inspec :selectedItem="selectedItem" :selected_item_ex="selected_item_ex" :finding_summary="finding_summary" :re_inspec_id="re_inspec_id"/>

    <v-dialog v-model="saving" persistent max-width="400">
      <v-card class="pa-20 textAlignCenter">
        <h1 class="dark-orange--text">{{saving===1?'...guardando':'Guardado'}}</h1>
        <br>
        <p>
          <v-icon>check</v-icon>
          <fs1-span>Re-inspección de hallazgo con código "{{selectedItem.finding_code}}".</fs1-span>
        </p>
        <br>  
        <v-btn color="secondary" @click="goToStep1">
          <span>cerrar</span>
        </v-btn>
      </v-card>
    </v-dialog>

    <fs1-dialog id="unfilled_reinspec" template="unfilled" max_width="400">
      <template v-slot:body>
        <ul class="textAlignLeft">
          <li v-for="(k,i) in unfilled" :key="i">{{unfilled_labels[k]}}</li>
        </ul>
      </template>
    </fs1-dialog>

    <fs1-dialog id="confirm_reinspec" template="warning" max_width="400">
      <template v-slot:body>
        <p>
          {{
            re_inspec_id
            ?'Esta acción modificará la presente inspección, ¿desea continuar?'
            :'Esta acción publicará la presente inspección, lo que archivará la inspección actualmente vigente. Esta acción no se puede deshacer, ¿desea continuar?'
          }}
        </p>
      </template>
    <template v-slot:footer="{close}">
      <v-btn color="primary" @click="()=>{close();save()}"><v-icon>save</v-icon>Continuar</v-btn>
      <v-btn color="secondary" @click="close">Cancelar</v-btn>
    </template>
    </fs1-dialog>

    <div class="mt-20" style="padding-bottom:40px">
      <div class="float-r">
        <v-btn color="secondary" @click="goToStep1">Volver</v-btn>
        <v-btn color="primary" @click="pre_save">Enviar</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import re_inspec from '@/modules/CA_SP/components/actions/re_inspec.vue';
import {finding} from '@/objects/general.js';
import { recursiveCopy } from '@/functions/general.js';

export default {
  components:{re_inspec},
  data() {
    return {
      re_inspec_id:null,
      selectedItem: recursiveCopy(finding),
      selected_item_ex:{
        inspection_date:null,
        update_max_remediation_date:true,
        comment:null,
      },
      finding_summary:null,
      //type:null,
      s_id:null,
      //s_finding_code:null,
      unfilled:[],
      unfilled_labels:{
        inspection_date: 'Fecha de inspección',
      },
      saving:0,      
      to_check: [
        'id',
        'likelihood',
        'priority',
        'computed_financial_mfl',
        'impact_percentage',
        'mfl_financial',
        'mfl_health_and_safety',
        'mfl_environment',
        'mfl_community',
        'mfl_legal',
        'mfl_reputation',
        'mfl_sustainability',
        'mfl_days',
        'ebit',
        'impact_type',
        'inspection_place',
        'inspection_date',
        'standard',
        'speciality',
        'process',
        'technical_report',
        'notebook_code',
        'sap_notice_inspection_number',
        'sap_ot_inspection_number',
        'description'
      ],
      to_save:{},
    };
  },
  created() {
    const {id,re_inspec} = this.$route.params
    this.s_id = id;
    /* this.enable_ignore_ebit_calculation = false; */
    if (id) this.requests.get['finding_summary'](id)
      .then(r=>{
        if(r) {
          this.finding_summary=r;
          if (re_inspec) {
            this.requests.get['get_finding_inspection/a'](re_inspec)
              .then(e=>{
                this.re_inspec_id = e.id;
                const {inspection_date,update_max_remediation_datecomment,comment} = e;
                this.selectedItem = { ...this.finding_summary.finding_data,...e};
                Object.assign(this.selected_item_ex,{inspection_date,update_max_remediation_datecomment,comment});
              })
          } else this.selectedItem = {...this.finding_summary.finding_data};
        }
      });
  },
  methods:{
    goToStep1(){
      this.$router.push({ 
        name: 'findings/edit_steps', 
        params: { k: 1, id:this.s_id },
        path: '/findings/edit_steps', 
        query: {key: 'not-sensitive'} 
      });
    },
    gotToList() {
      this.$router.push({ name: 'findings'})
    },
    check(p) {
      const toCheck = p || this.selectedItem;
      const list = [];
      [ 
        'inspection_date',
      ].forEach(c => toCheck[c] === null && list.push(c));
      return list;
    },
    pre_save(){
      this.to_save = {};
      this.to_check.forEach(e=>this.to_save[e]=this.selectedItem[e]);
      [
        'inspection_date',
        'update_max_remediation_date',
        'comment',
      ].forEach(e=>this.to_save[e]=this.selected_item_ex[e]);

      this.unfilled = this.check(this.to_save);
      if (this.unfilled.length > 0) return this.open_dialog('unfilled_reinspec');
      else this.open_dialog('confirm_reinspec');
    },
    save(){
      this.saving = 1;
      if(this.re_inspec_id) this.to_save.id = this.re_inspec_id;
      this.requests.patch[this.re_inspec_id?'edit_finding_inspection_date/a':'add_finding_inspection_date/a'](this.to_save)
        .then(r => {
          this.saving = 2;
        })
    }
  }
};
</script>
